export default (label, min = 255) => ({
  min,
  type: 'string',
  message: `${label} field must be at least ${min} characters.`,
  trigger: 'blur',
})
